export enum MaritzSetting {
    None = 'None',
    Maritz = 'Maritz',
    MaritzIntuit = 'MaritzIntuit',
    MaritzWarnerMedia = 'MaritzWarnerMedia',
    OCTanner = 'OCTanner'
}
